import { PayloadAction } from '@reduxjs/toolkit';
import { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import { call, put, takeLatest } from 'redux-saga/effects';

import { restCall } from '@/core/clients/rest';
import type oas from '@/services/rest/base/openapi';

import { appSettingsActions } from '../app/slice';
import { usersActions } from '../users/slice';

import { subscriptionActions } from './slice';

type SubscriptionListResponse = OASOutput<
  NormalizeOAS<typeof oas>,
  '/subscriptions/plans',
  'get',
  '200'
>;

type BuySubscriptionRequest = OASOutput<
  NormalizeOAS<typeof oas>,
  '/subscriptions',
  'post'
>;

function* fetchSubscriptionsList(): Generator<
  any,
  void,
  SubscriptionListResponse
> {
  try {
    const response = yield call(restCall, '/subscriptions/plans', 'get');
    yield put(subscriptionActions.setSubscriptionsList(response));
  } catch (error) {
    console.log('Error on fetchSubscriptionsList:', error);
  }
}

function* fetchBuySubscription(
  action: PayloadAction<any>
): Generator<any, void, BuySubscriptionRequest> {
  const { payload } = action;

  try {
    const response = yield call(restCall, '/subscriptions', 'post', {
      json: {
        ...payload,
      },
    });
    window.open(response);
  } catch (error: any) {
    console.log('Error on fetch Buy Subscription:', error?.message);
    if (error?.message) {
      yield put(
        appSettingsActions.setAppNotification({
          type: 'error',
          message: 'Ошибка',
          description: error?.message,
        })
      );
    }
  }
}

function* fetchCancelAutoRenewalOfSubscription(): Generator<any, void, any> {
  try {
    const response = yield call(
      restCall,
      '/subscriptions/disable_auto_renew',
      'post'
    );

    yield put(
      appSettingsActions.setAppMessage({
        type: 'success',
        content: 'Успешно отключено',
      })
    );
    yield put(usersActions.fetchUser());
  } catch (error) {
    console.log('Error canceling automatic subscription renewal:', error);
    yield put(
      appSettingsActions.setAppNotification({
        type: 'error',
        message: 'Отмена подписки',
        description: 'Что-то пошло не так',
      })
    );
  }
}

export const subscriptionsSagas = [
  takeLatest(
    subscriptionActions.fetchSubscriptionsList,
    fetchSubscriptionsList
  ),
  takeLatest(subscriptionActions.fetchBuySubscription, fetchBuySubscription),
  takeLatest(
    subscriptionActions.fetchCancelAutoRenewalOfSubscription,
    fetchCancelAutoRenewalOfSubscription
  ),
];
